import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #c2c6da;
  border-radius: 10.39px;
  height: 99vh;
  width: 99vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: right;
`;

export const PrivacyTitle = styled.span`
  font-size: 7vh;
  margin-top: "";
  font-weight: bold;
  color: #011f59;
`;

export const Paragarph = styled.p`
  font-size: 2vmax;
  color: #989ea9;
  width: 80%;
  text-align: center;
  font-size: 4.285714285714286vh;
  color: #616a7b;
  line-height: 6.6vh;
  margin: 0;
`;

export const ParagarphContainer = styled.div`
  height: 83%;
  overflow: auto;
  padding-left: 2vmax;
  padding-right: 2vmax;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 91%;
  justify-content: space-evenly;
`;

export const Button = styled.div`
  color: white;
  cursor: pointer;
  background: #5776ff;
  border-radius: 17.02px;
  height: fit-content;
  padding: 1vmax;
  width: 35%;
  text-align: center;
  height: 10.6vh;
  font-size: 6vh;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #3f5ed1;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Link = styled.span`
  color: #5776ff;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 4vh;
  font-size: 5.363984674329502vh;
`;
